import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateLeaveRemarks } from '../../../store/slices/leaveManagementSlice';
import './EditLeaveRemarksModal.scss';

const EditLeaveRemarksModal = ({ leave, onClose }) => {
  const dispatch = useDispatch();
  const { updatingRemarks, updateRemarksError } = useSelector(state => state.leaveManagement);
  
  const [remarks, setRemarks] = useState(leave.leaveRemarks || '');
  
  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    dispatch(updateLeaveRemarks({
      leaveId: leave.id,
      remarks
    }))
      .unwrap()
      .then(() => {
        onClose();
      })
      .catch((err) => {
        console.error('Failed to update remarks:', err);
      });
  };
  
  return (
    <div className="modal-overlay">
      <div className="edit-remarks-modal">
        <div className="modal-header">
          <h3>Edit Leave Remarks</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="leaveRemarks">Remarks</label>
              <textarea
                id="leaveRemarks"
                value={remarks}
                onChange={handleRemarksChange}
                rows="4"
                placeholder="Enter your remarks for this leave request"
              ></textarea>
            </div>
            
            {updateRemarksError && (
              <div className="error-alert">
                Failed to update remarks: {updateRemarksError}
              </div>
            )}
          </div>
          
          <div className="modal-footer">
            <button 
              type="button" 
              className="cancel-btn"
              onClick={onClose}
              disabled={updatingRemarks}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="save-btn"
              disabled={updatingRemarks}
            >
              {updatingRemarks ? (
                <>
                  <span className="spinner"></span>
                  Saving...
                </>
              ) : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditLeaveRemarksModal; 